import styled from 'styled-components';
import { SwitchGroup } from '../../../components/shared/Form/Form.styles';

export const SettingsContainer = styled.div`
  background: var(--bg-section);
  min-height: calc(100vh - 68px);
  padding: 40px 20px 72px;

  > * {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const SettingsHeader = styled.header`
  margin-bottom: 28px;

  h1 {
    font-size: var(--text-3xl);
    letter-spacing: -0.5px;
    margin-bottom: 4px;
  }

  p {
    color: var(--text-secondary);
  }
`;

export const SettingsCard = styled.div`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  margin-bottom: 20px;
`;

export const SettingsSection = styled.section`
  padding: 28px;

  h2 {
    font-size: var(--text-lg);
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 10px;

    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 18px;
      background: var(--primary);
      border-radius: 2px;
    }
  }

  button[type='submit'],
  > button {
    margin-top: 8px;
  }

  @media (max-width: 560px) {
    padding: 20px 16px;
  }
`;

export const DangerZone = styled.div`
  background: var(--danger-subtle);
  border: 1px solid var(--danger-light);
  border-radius: var(--radius-lg);
  margin-bottom: 20px;

  h2 {
    color: var(--danger-dark);

    &::before {
      background: var(--danger) !important;
    }
  }
`;

export const HoursRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-sm) var(--spacing-md);
  margin-bottom: 12px;
  padding: 12px;
  background: var(--bg-section);
  border-radius: var(--radius-sm);

  > ${SwitchGroup} { margin: 0; }
`;

export const HoursDay = styled.div`
  min-width: 100px;
  color: var(--text-primary);
`;

export const HoursTimes = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: 1 1 220px;
  min-width: 0;

  > input { flex: 1; min-width: 0; }
  > span { color: var(--text-secondary); }
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  flex-wrap: wrap;
  min-width: 0;
`;

export const LogoPreview = styled.div`
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-light);
  background: var(--bg-input);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--text-muted);
  font-size: var(--text-3xl);
  font-weight: 700;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

export const LogoActions = styled.div`
  flex: 1 1 200px;
  min-width: 0;

  small {
    display: block;
    margin-top: var(--spacing-sm);
    color: var(--text-muted);
    font-size: var(--text-xs);
  }

  p[role='alert'] {
    margin-top: var(--spacing-sm);
    color: var(--danger-dark);
    font-size: var(--text-sm);
  }
`;

export const LogoButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
`;
